import React, { useState, useEffect } from 'react'
import { Row, Col, Form, Button, Table } from 'react-bootstrap'
import Message from '../components/Message'
import Loader from '../components/Loader'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { getUserDetailsAction, updateUserProfileAction, userLogoutAction } from '../actions/userActions'
import { USER_UPDATE_PROFILE_RESET } from '../constants/userConstants'
import { LinkContainer } from 'react-router-bootstrap'
import { getMyOrderList } from '../actions/orderActions'
import { FRONT_URL } from '../constants/urlConstants'


function ProfileScreen() {
  const history = useNavigate()
  //local state
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [message, setMessage] = useState('')
  const [successUpdate, setSuccessUpdate] = useState('')


  //handle getuserdetails
  const dispatch = useDispatch()
  const userLogin = useSelector(state => state.userLogin)
  const { userInfo } = userLogin

  const userDetails = useSelector(state => state.userDetails)
  const { user, error: errorUserDetails, loading: loadingUserDetails } = userDetails

  const userUpdateProfile = useSelector(state => state.userUpdateProfile)
  const { success, error: errorUserUpdateProfile, loading: loadingUserUpdateProfile } = userUpdateProfile

  // handle getMyOrderList
  const orderListMy = useSelector(state => state.orderListMy)
  const { orders, error: errorOrders, loading: loadingOrders } = orderListMy


  //چون از دو اکشن جدا استفاده کردیم loading and error  را باید مدیریت کنیم
  var loading = false
  var error = ''

  if (loadingUserDetails || loadingUserUpdateProfile) {
    loading = true
  }

  if (errorUserDetails) {
    error = errorUserDetails
  } else if (errorUserUpdateProfile) {
    error = errorUserUpdateProfile
  }

  const TE = "Invalid token specified: must be a string"

  useEffect(() => {
    if (errorUserDetails === TE || errorUserUpdateProfile === TE) {
      dispatch(userLogoutAction());
      history('/login?redirect=/profile');
    }
    if (!userInfo) {
      history('/login')
    } else {
      if (!user || !user.name || success) {
        dispatch({ type: USER_UPDATE_PROFILE_RESET })
        dispatch(getUserDetailsAction('profile'))
        dispatch(getMyOrderList())
      } else {
        setEmail(user.email)
        setName(user.name)
      }
    }
  }, [history, userInfo, dispatch, user, success, errorUserDetails, errorUserUpdateProfile])


  const submitHandler = (e) => {
    e.preventDefault()
    if (password !== confirmPassword) {
      setMessage('password do not match')
    } else {
      dispatch(updateUserProfileAction({
        'id': user._id,
        'name': name,
        'email': email,
        'password': password
      }))
      setMessage('')
      setPassword('')
      setConfirmPassword('')
      setSuccessUpdate('profile successfully updated..! ')

    }
  }


  return (

    <Row>
      <Col md={3}>
        <h2>my profile</h2>

        {
          loading ? <Loader />
            : error ? <Message variant='danger' text={error} />
              : message ? <Message variant='danger' text={message} />
                : successUpdate ? <Message variant='success' text={successUpdate} />
                  : <></>
        }


        <Form onSubmit={submitHandler}>
          <Form.Group controlId='name'>
            <Form.Label>FullName</Form.Label>
            <Form.Control type='text' placeholder='Enter FullName' value={name} onChange={(e) => setName(e.target.value)}></Form.Control>
          </Form.Group>
          <Form.Group className='mt-4' controlId='email'>
            <Form.Label>Email</Form.Label>
            <Form.Control type='email' placeholder='Enter Email' value={email} onChange={(e) => setEmail(e.target.value)}></Form.Control>
          </Form.Group>
          <Form.Group className='mt-4' controlId='password'>
            <Form.Label>Password</Form.Label>
            <Form.Control type='password' placeholder='Enter Password' value={password} onChange={(e) => setPassword(e.target.value)}></Form.Control>
          </Form.Group>
          <Form.Group className='mt-4' controlId='confirmPassword'>
            <Form.Label>ConfirmPassword</Form.Label>
            <Form.Control type='password' placeholder='Enter ConfirmPassword' value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)}></Form.Control>
          </Form.Group>
          <Button type='submit' className='my-4 col-4'>update</Button>
        </Form>
      </Col>
      <Col md={9}>
        <h2>سفارش من</h2>

        {
          loadingOrders ? (
            <Loader />
          ) : errorOrders ? (
            <Message variant='danger' text={errorOrders} />
          ) : orders && orders.length === 0 ? (
            <Message variant='warning' text='There is no any order !' />
          ) : (
            <Table striped responsive className='table-sm text-center'>
              <thead>
                <tr>
                  <th>id</th>
                  <th>date</th>
                  <th>total</th>
                  <th>paid</th>
                  <th>delivered</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {
                  orders.map(order => (
                    <tr
                      key={order._id}
                      className={order.isPaid && order.isDelivered ? "bg-success text-white" : ''}
                    >
                      <td>#{order._id}</td>
                      <td>{order.createdAt.substring(0, 10)}</td>
                      <td>$ {order.totalPrice}</td>
                      <td>
                        {
                          order.isPaid ?
                            order.paidAt.substring(0, 10) : (
                              <i className='fas fa-times text-danger'></i>
                            )
                        }
                      </td>
                      <td>
                        {
                          order.isDelivered ?
                            order.deliveredAt.substring(0, 10) : (
                              <i className='fas fa-times text-danger'></i>
                            )
                        }
                      </td>
                      <td>
                        <LinkContainer to={`${FRONT_URL}/order/${order._id}`}>
                          <Button
                            className='btn-sm'
                          >
                            details
                          </Button>
                        </LinkContainer>
                      </td>
                    </tr>
                  ))
                }
              </tbody>
            </Table>
          )
        }


      </Col>
    </Row>


  )
}

export default ProfileScreen
